// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Result_wrapper__34KHE","link":"Result_link__2qUfz","tasks":"Result_tasks__1U4dd"};